import { SalesforceActions } from 'module/api/integrations/salesforce/types';
import styled from 'styled-components';
import { BlockList } from 'components/organisms/signal/detail/block-list/list';
import { Wrapper } from 'components/organisms/signal/detail/components';
import { AutomationChoicesBlock } from './automation-choices';
import { useAutomationContext } from './automation-context';
import { AutomationMatchingConditons } from './automation-matching-conditons';
import { AutomationNameBlock } from './automation-name';
import { AutomationContact } from '../AutomationContact';
import { AutomationAccountBlock } from './blocks/automation-account-block';
import { AutomationProjectBlock } from './blocks/automation-project-block';
import { AutomationThenBlock } from './blocks/then-block';
import { AutomationObjectPickerBlock } from './object-picker';
import { AutomationTriggerConditionBlock } from './trigger-condition';

const ContentWrapper = styled.div`
  max-width: 800px;
  width: 100%;
  ${BlockList} {
    padding-bottom: var(--spacing-10);
  }
`;

function CreateAutomation() {
  const { automationDetails } = useAutomationContext();
  const { salesForceType } = automationDetails || {};
  const isProjectSelected = salesForceType === SalesforceActions.Project;
  const isAccountSelected = salesForceType === SalesforceActions.Account;

  return (
    <Wrapper>
      <ContentWrapper>
        <BlockList>
          <AutomationNameBlock />
          <AutomationObjectPickerBlock />
          <AutomationTriggerConditionBlock />
          <AutomationMatchingConditons />
          <AutomationThenBlock>
            <div className="flex flex-col gap-4 heading-01">Then</div>
            <AutomationChoicesBlock />
            {isProjectSelected && <AutomationProjectBlock />}
          </AutomationThenBlock>
          {(isProjectSelected || isAccountSelected) && (
            <AutomationThenBlock>
              <div className="flex flex-col gap-4 heading-01">
                Setup Rocketlane Account field mapping
              </div>
              <AutomationAccountBlock />
            </AutomationThenBlock>
          )}
          {(isProjectSelected || isAccountSelected) && <AutomationContact />}
        </BlockList>
      </ContentWrapper>
    </Wrapper>
  );
}

export { CreateAutomation };
